import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notesInput", "termsCheck", "amendButton", "confirmButton"]

  static classes = ["disabled"]

  connect() {
    this.toggleButtons({ target: this.termsCheckTarget })
  }

  toggleNotes({ target }) {
    const enable = target.value
    this.#disable(this.amendButtonTarget, !enable)
  }

  toggleButtons({ target }) {
    const enable = target.checked
    this.#disable(this.confirmButtonTarget, !enable)
    this.#disable(this.amendButtonTarget, !enable)
    this.toggleNotes({ target: this.notesInputTarget })
  }

  #disable(target, disabled) {
    target.classList.toggle(this.disabledClass, disabled)
    target.disabled = disabled
  }
}
